import { render } from "./FailureAlartBase.vue?vue&type=template&id=45a2b110"
import script from "./FailureAlartBase.vue?vue&type=script&lang=js"
export * from "./FailureAlartBase.vue?vue&type=script&lang=js"

import "./FailureAlartBase.vue?vue&type=style&index=0&id=45a2b110&lang=css"
script.render = render

export default script